import navbarLogo from '@/assets/themes/aham37/navbar-logo.svg';
import chatAvatar from '@/assets/themes/aham37/chat-avatar.svg';
import favicon from '@/assets/themes/aham37/favicon.ico';
import { getMarqueeLogos } from '../marqueeLogos';
import type { ThemeDefinition } from '../types';

export const aham37Theme: ThemeDefinition = {
  id: 'aham37',
  name: 'AHAM37',
  pageTitle: 'AHAM37 Platform',
  assets: {
    navbarLogo,
    fullLogo: navbarLogo, // dark version — visible on white backgrounds
    chatAvatar,
    favicon,
    clerkLogoUrl: 'https://assets.apps.strivelabs.co/public-assets/aham37-black.svg',
  },
  onboarding: {
    marqueeHeadline: 'Move faster with AHAM37.',
    marqueeBody: [
      'AHAM37 brings strategy, execution, and measurement into one connected system — helping your team move from ideas to action faster across SEO, paid, content, and AI search.',
      'One platform to ideate, execute, and measure. Let’s get started.',
    ],
    marqueeTrustCaption: 'Trusted by marketing teams at fast-growing companies',
    marqueeLogos: getMarqueeLogos('aham37'),
  },
};
